import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import NanoPulseLogo from "../assets/NanoPulseLogo1.png";
import LoginModal from "./LoginModal";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showLogin, setShowLogin] = useState(false);

  return (
    <div style={{ fontFamily: "Arial, sans-serif" }}>

      {/*  TOP HEADER */}
      <div style={styles.topWrapper}>

        {/* WHITE CUT SHAPE */}
        <div style={styles.whiteCut}></div>

        {/* BLUE BAR */}
        <div style={styles.topBar}>
          <div style={styles.topContent}>
            <span>Welcome to NanoPulse</span>

            <div style={styles.socialIcons}>

              <a
                href="https://www.facebook.com/people/Nano-Cloud-Technology/61579555775024/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#fff" }}
              >
                <i className="pi pi-facebook" />
              </a>

              <a
                href="https://www.linkedin.com/company/nano-cloud-technology/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#fff" }}
              >
                <i className="pi pi-linkedin" />
              </a>

              <a
                href="https://www.instagram.com/nanocloudtechnology/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#fff" }}
              >
                <i className="pi pi-instagram" />
              </a>

              <a
                href="https://nanocloudtechnology.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#fff" }}
              >
                <i className="pi pi-google" />
              </a>

            </div>
          </div>
        </div>

        {/* BLACK BUTTON */}
        <div style={styles.login}
          onClick={() => setShowLogin(true)}
        >
          <button style={styles.loginBtn}>Login</button>
        </div>
      </div>

      {/*  MIDDLE SECTION */}
      <div style={styles.middleBar}>
        <div style={styles.middleContainer}>

          {/* LOGO */}
          <img src={NanoPulseLogo} alt="logo" style={styles.logo} />

          {/* INFO ITEMS */}
          <div style={styles.infoWrapper}>

            <div style={styles.infoBox}>
              <i className="pi pi-home" style={styles.infoIcon} />
              <div>
                <strong style={{ fontSize: "18px" }}>Address</strong>
                <p style={styles.infoText}>Bhubaneswar, Odisha, India</p>
              </div>
            </div>

            <div style={styles.infoBox}>
              <i className="pi pi-envelope" style={styles.infoIcon} />
              <div>
                <strong style={{ fontSize: "18px" }}>Email</strong>
                <p style={styles.infoText}>
                  <a
                    href="mailto:support@nanopulse.in"
                    style={{ textDecoration: "none", color: "#555" }}
                  >
                    support@nanopulse.in
                  </a>
                </p>
              </div>
            </div>

            <div style={styles.infoBox}>
              <i className="pi pi-clock" style={styles.infoIcon} />
              <div>
                <strong style={{ fontSize: "18px" }}>Working Hours</strong>
                <p style={styles.infoText}>Mon-Sat: 10:00am - 7:00pm</p>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/*  NAVBAR */}
      <div style={styles.blackCut}></div>
      <div style={styles.navBar}>
        <div style={styles.navContainer}>

          <span
            style={location.pathname === "/" ? styles.activeNav : styles.navItem}
            onClick={() => navigate("/")}
          >
            HOME
          </span>

          <span
            style={location.pathname === "/about" ? styles.activeNav : styles.navItem}
            onClick={() => navigate("/about")}
          >
            ABOUT
          </span>

          <span
            style={location.pathname === "/contact" ? styles.activeNav : styles.navItem}
            onClick={() => navigate("/contact")}
          >
            CONTACT
          </span>

          <span
            style={location.pathname === "/partner" ? styles.activeNav : styles.navItem}
            onClick={() => navigate("/partner")}
          >
            PARTNER
          </span>

        </div>
      </div>

      {/* LOGIN MODAL */}
      {showLogin && (
        <LoginModal
          onClose={() => setShowLogin(false)}
          onLoginSuccess={() => {
            setShowLogin(false);
            navigate("/admin");
          }}
        />
      )}

    </div>
  );
};

export default Header;

/* ================= STYLES ================= */

const styles = {

  /*  TOP WRAPPER */
  topWrapper: {
    display: "flex",
    alignItems: "center",
    position: "relative",
  },

  whiteCut: {
    position: "absolute",
    left: "-60px",
    width: "360px",
    height: "45px",
    background: "#fff",
    transform: "skewX(40deg)",
    transformOrigin: "left",
    zIndex: 2,
  },

  /*  BLUE BAR */
  topBar: {
    flex: 1,
    background: "#2f66b1",
    color: "#fff",
    height: "45px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "160px",
  },

  topContent: {
    width: "70%",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  socialIcons: {
    display: "flex",
    gap: "14px",
    width: "2%",
    cursor: "pointer",
  },

  /*  Login */
  login: {
    background: "#111",
    height: "45px",
    display: "flex",
    alignItems: "center",
    padding: "0 25px",
  },

  loginBtn: {
    background: "transparent",
    border: "none",
    color: "#fff",
    fontWeight: "700",
    cursor: "pointer",
  },

  /* MIDDLE */
  middleBar: {
    background: "#fff",
    padding: "0px 0",
    lineHeight: "1.5",
  },

  middleContainer: {
    width: "100%",
    margin: "auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  logo: {
    height: "90px",
    objectFit: "contain",
  },

  infoWrapper: {
    display: "flex",
    gap: "40px",
  },

  infoBox: {
    display: "flex",
    alignItems: "center",
    gap: "18px",
  },

  infoText: {
    margin: 0,
    fontSize: "16px",
    color: "#555",
  },
  infoIcon: {
    fontSize: "40px",
    color: "#555",
  },

  /*  NAVBAR */
  navBar: {
    background: "#111111",
  },
  blackCut: {
    position: "absolute",
    left: "-60px",
    width: "360px",
    height: "40px",
    background: "#fff",
    transform: "skewX(-40deg)",
    transformOrigin: "left",
    zIndex: 2,
  },

  navContainer: {
    width: "45%",
    margin: "auto",
    display: "flex",
    gap: "50px",
  },

  navItem: {
    color: "#fff",
    padding: "8px 0",
    cursor: "pointer",
  },

  activeNav: {
    background: "#2f66b1",
    padding: "8px 15px",
    color: "#fff",
    fontWeight: "600",
    cursor: "pointer",
  },
};